import { ILeaveDayDetails } from '../types/leave-request'
import { IWorkDay } from '../types/work-week'

export interface ILeaveHoursForPeriod {
  leaves: IWorkDay[]
  usedHours: number
  totalHours: number
}

export interface ILeaveHoursForPeriods {
  current: ILeaveHoursForPeriod
  next: ILeaveHoursForPeriod
}

/**
 * Get leave hours for current and next period from leave days array
 * @param leaveDays - leave days
 * @param nextYearStart - next year start date
 * @returns leave hours for current and next period
 */
export function getLeaveHoursForCurrentAndNextPeriod(leaveDaysList: IWorkDay[] | ILeaveDayDetails[], nextYearStart: Date) {
  const leaveDays = (typeof leaveDaysList[0]?.day === 'string')
    ? leaveDaysList.map(workDay => ({
      ...workDay,
      day: new Date(workDay.day as string),
    })) as IWorkDay[]
    : leaveDaysList as IWorkDay[]

  const currentPeriodLeaves: IWorkDay[] = []
  const nextPeriodLeaves: IWorkDay[] = []
  leaveDays.forEach((workDay: IWorkDay) => {
    const workDayTimestamp = workDay.day.getTime()
    const nextYearTimestamp = nextYearStart.getTime()
    if (workDayTimestamp < nextYearTimestamp) {
      currentPeriodLeaves.push(workDay)
    } else if (workDayTimestamp >= nextYearTimestamp) {
      nextPeriodLeaves.push(workDay)
    }
  })

  return {
    current: {
      leaves: currentPeriodLeaves,
      usedHours: currentPeriodLeaves.reduce((acc, workDay) => acc + workDay.leaveHours, 0),
      totalHours: currentPeriodLeaves.reduce((acc, workDay) => acc + workDay.workingHoursInDay, 0),
    },
    next: {
      leaves: nextPeriodLeaves,
      usedHours: nextPeriodLeaves.reduce((acc, workDay) => acc + workDay.leaveHours, 0),
      totalHours: nextPeriodLeaves.reduce((acc, workDay) => acc + workDay.workingHoursInDay, 0),
    },
  }
}
